import React from 'react'
import {Link} from "react-router-dom"
import _checkRoles from "../../helpers/checkRole";

function InformationUserContainer(props) {
    const {isActive} = props

    return (
        <div className="InformationUserContainer">
            <div className="MenuLeft">
                <ul>
                    <li>
                        <Link to="/crm/users/change-password"
                              className={isActive === 'change-password' ? 'Active' : ''}>
                            Đổi mật khẩu
                        </Link>
                    </li>
                    {_checkRoles('menu.user.followMe') && <li>
                        <Link to="/crm/users/follow-me" className={isActive === 'followMe' ? 'Active' : ''}>
                            Follow Me
                        </Link>
                    </li>}
                    <li>
                        <Link to="/crm/users/information-user" className={isActive === 'information' ? 'Active' : ''}>
                            Thông tin
                        </Link>
                    </li>
                    {_checkRoles('menu.user.billing') && <li>
                        <Link to="/crm/balance-manager"
                              className={isActive === 'balance' ? 'Active' : ''}>Balance</Link>
                    </li>}
                </ul>
            </div>
            <div className="ContentPage">
                {props.children}
            </div>
        </div>
    )
}

InformationUserContainer.defaultProps = {
    isActive: 'change-password'
}

export default InformationUserContainer
